import { PubSub } from "@/shared/utils/pubSub";

type PlaceClearedCallback = (fieldPath: string) => void;

/**
 * Neutral pub-sub channel for "the place's gpid was cleared by editing its text".
 *
 * `PlaceAutocompleteField.handleChange` publishes when a user edit clears a
 * previously non-empty gpid. It never publishes on a clear that had nothing to
 * clear (gpid was already empty), and it is not a place-selection event (see
 * `placeSelectionPubSub`) — no place was chosen, one was un-set.
 *
 * `PlaceExactness` subscribes, filtered to its own `fieldPath`, and collapses any
 * level-based expansion in the stored scope: a scope that carried a level (e.g.
 * State non-adjacent) is relative to an `IdHierarchy` that no longer exists once
 * gpid is null, so it resets to the plain "exact to this place" scope (`ThisPlace`).
 * A scope that was already Broad (`null`) is left untouched — see
 * "Exactness outlives gpid" in the design doc.
 */
export const placeClearedPubSub = new PubSub<PlaceClearedCallback>();
